import React from "react";
import "../invoiceList/invoice.scss";
import "react-datepicker/dist/react-datepicker.css";
import SaveSuccessModel from "../../components/invoiceList/SaveSuccessModel";
import SubAddNewInvoice from "../../components/invoiceList/SubAddNewInvoice";

const AddNewInvoice = () => {
  return (
    <div className="container-fluid add-new-invoice-sec">
      <section className="invoice-add-sec mt-3">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <SubAddNewInvoice />
          </div>
        </div>
      </section>

      {/* <!-- saveSuccessModal start--> */}
      <SaveSuccessModel SuccessName="Invoice created successfully" />
    </div>
  );
};

export default AddNewInvoice;
